const state = {
  menus: [
    {
      text: "Summary",
      href: "/web/summary/summaryPatientView",
      name: "overview",
      icon: "fa-house fa-solid fa-sm",
    },
    {
      text: "Additional Documents",
      href: "/web/additional-documents",
      name: "downloadArea",
      icon: "fa-archive fa-solid",
    },
    {
      text: "Information for Healthcare Professionals",
      href: "/web/information-for-healthcare-professionals",
      name: "professionalInfo",
      icon: "fa-info-circle fa-solid",
    },
  ],
};

export default state;
